import React from "react";
const defaultWorkforceData1 = [
  {
    metric: "Total recordable incident rate (TRIR)",
    directEmployees: "",
    contactEmployees: "",
  },
  {
    metric: "Fatality rate",
    directEmployees: "",
    contactEmployees: "",
  },
];

const WorkforceTable1 = ({ workforceTable1, setWorkforceTable1 }) => {
  const safeWorkforceTable1 = Array.isArray(workforceTable1)
    ? workforceTable1
    : defaultWorkforceData1;

  const handleInputChange = (rowIndex, field, value) => {
    const updatedData = [...safeWorkforceTable1];
    updatedData[rowIndex][field] = value;
    setWorkforceTable1(updatedData);
  };

  return (
    <div>
      <div
        style={{
          marginTop: "20px",
          border: "1px solid #000",
          borderRadius: "8px",
          overflow: "hidden",
          width: "100%",
        }}
      >
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr
              style={{
                backgroundColor: "#D3C9CE",
                color: "#000",
                fontWeight: "bold",
              }}
            >
              <th style={tableHeaderStyle}>Metric</th>
              <th style={tableHeaderStyle}>Direct Employees</th>
              <th style={tableHeaderStyle}>Contact Employees</th>
            </tr>
          </thead>
          <tbody>
            {safeWorkforceTable1.map((row, index) => (
              <tr key={index}>
                <td
                  style={{
                    ...tableCellStyle,
                    backgroundColor: "#f5f5f5",
                    fontWeight: "bold",
                  }}
                >
                  {row.metric}
                </td>
                <td style={tableCellStyle}>
                  <input
                    type="number"
                    value={row.directEmployees}
                    onChange={(e) =>
                      handleInputChange(
                        index,
                        "directEmployees",
                        e.target.value
                      )
                    }
                    style={inputFieldStyle}
                  />
                </td>
                <td style={tableCellStyle}>
                  <input
                    type="number"
                    value={row.contactEmployees}
                    onChange={(e) =>
                      handleInputChange(
                        index,
                        "contactEmployees",
                        e.target.value
                      )
                    }
                    style={inputFieldStyle}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const tableHeaderStyle = {
  padding: "10px",
  border: "1px solid #000",
  textAlign: "center",
};

const tableCellStyle = {
  padding: "10px",
  border: "1px solid #000",
  textAlign: "center",
};

const inputFieldStyle = {
  width: "100%",
  padding: "6px",
  borderRadius: "4px",
  border: "1px solid grey",
  textAlign: "center",
  fontSize: "14px",
  backgroundColor: "white",
  outline: "none",
};

export default WorkforceTable1;
